import { render, staticRenderFns } from "./BienAlertEmail.vue?vue&type=template&id=2523ebe3&"
import script from "./BienAlertEmail.vue?vue&type=script&lang=js&"
export * from "./BienAlertEmail.vue?vue&type=script&lang=js&"
import style0 from "./BienAlertEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports